import {
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonContent,
    IonFab,
    IonFabButton,
    IonHeader,
    IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonList,
    IonMenuButton,
    IonModal,
    IonPage,
    IonPopover,
    IonTitle,
    IonToggle,
    IonToolbar,
    useIonAlert,
    useIonPicker
} from "@ionic/react";
import React, {useEffect, useState} from "react";
import './DertigenList.css';
import {useHistory, useParams} from 'react-router-dom'
import createAxiosInstance from "../../services/AxiosInstance";
import {useStomp} from "../../services/useStomp";
import {DertigenEvent} from "../../model/DertigenEvent";
import {DertigenPlayer} from "../../model/DertigenPlayer";
import {Lobby} from "../../model/Lobby";
import {User} from "../../model/User";
import {
    addCircleOutline,
    arrowDownCircleOutline,
    arrowUpCircleOutline,
    beer,
    chevronDownOutline,
    chevronUpOutline,
    flashOutline,
    helpCircleSharp,
    ribbon,
    scanCircleOutline,
    settingsOutline
} from "ionicons/icons";
import { useToast } from "../../utils/useToasts";
import DiceContainer from "../../components/dertigen/DiceContainer";
import ProfilePicture from "../../components/shared/ProfilePicture";
import DertigenMoveInput from "./DertigenMoveInput";
import ReorderPlayers from "../../components/dertigen/ReorderPlayers";
import DrinkStripesPopOver from "../../components/dertigen/DrinkStripesPopOver";
import {IDetectedBarcode, Scanner} from "@yudiel/react-qr-scanner";

const DertigenList: React.FC = () => {

    const [lobby, setLobby] = useState<Lobby>();
    const [user, setUser] = useState<User>();
    const [players, setPlayers] = useState<DertigenPlayer[]>([])
    const {lobbyId} = useParams<{ lobbyId?: string }>();
    const showToasts = useToast();
    const [presentPicker] = useIonPicker();
    const [presentAlert] = useIonAlert();
    const axios = createAxiosInstance();

    // UI toggles
    const [showLastMove, setShowLastMove] = useState(true);
    const [clockWise, setClockWise] = useState<boolean>(true);
    const [showPlayDirection, setShowPlayDirection] = useState<boolean>(true);
    const [showDices, setShowDices] = useState<boolean>(false);
    const [showBuyedOutPlayers, setShowBuyedOutPlayers] = useState<boolean>(true);
    const [showProfilePictures, setShowProfilePictures] = useState<boolean>(true);
    const [showRemoveMovePanel, setShowRemoveMovePanel] = useState<boolean>(false);
    const [isDesktop, setIsDesktop] = useState<boolean>(false);
    const [expandedByPlayerId, setExpandedByPlayerId] = useState<Record<number, boolean>>({});

    // moves + recent
    const [lastMove, setLastMove] = useState<DertigenEvent>();
    const [recentMoves, setRecentMoves] = useState<DertigenEvent[]>([]);
    const [showRecentMoves, setShowRecentMoves] = useState(false);

    // dialogs
    const [showDialog, setShowDialog] = useState(false);
    const [showAddPlayerModal, setShowAddPlayerModal] = useState(false);

    // add-player helpers
    const [previousPlayers, setPreviousPlayers] = useState<User[]>([]);
    const [searchTerm, setSearchTerm] = useState('');

    // turn info
    const [currentPlayerOnTurn, setCurrentPlayerOnTurn] = useState<User>();
    const [throwForPlayerId, setThrowForPlayerId] = useState<number>();

    const history = useHistory();
    const [isReorderVisible, setIsReorderVisible] = useState(false);
    const [showPopover, setShowPopover] = useState(false);
    const [playerToOpenPopoverFor, setPlayerToOpenPopoverFor] = useState<DertigenPlayer>();
    const [showQrReader, setShowQrReader] = useState<boolean>(false);
    const [showHeaderActionsMenu, setShowHeaderActionsMenu] = useState<boolean>(false);
    const [headerActionsMenuEvent, setHeaderActionsMenuEvent] = useState<Event | undefined>(undefined);
    const {sendMessage, subscribe, status} = useStomp();
    const [pingMs, setPingMs] = useState<number | null>(null);

    const [scannerContraints, setScannerContraints] = useState<MediaTrackConstraints>({facingMode: 'environment'});

    const measurePing = async () => {
        const pingPath =  '/ping/ping';
        const start = performance.now();

        try {
            await axios.get(pingPath, {validateStatus: () => true});
            setPingMs(Math.round(performance.now() - start));
        } catch {
            setPingMs(null);
        }
    };

    const toggleReorderVisibility = () => setIsReorderVisible(!isReorderVisible);

    const openPopover = (e: any, playerId: DertigenPlayer) => {
        setPlayerToOpenPopoverFor(playerId);
        setShowPopover(true);
    };

    const showLastMoveToggle = () => setShowLastMove(!showLastMove);
    const showBuyedOutPlayersToggle = () => setShowBuyedOutPlayers(!showBuyedOutPlayers);
    const showProfilePicturesToggle = () => setShowProfilePictures(!showProfilePictures);

    const addNewPlayerToLobby = (name: string) => {
        const newUser: User = {name};
        axios.post(`/user/`, newUser)
            .then(res => {
                axios.patch(`/lobbies/${lobbyId}/join/${res.data.id}`)
                    .then(() => showToasts('Speler toegevoegd!', 'success'))
                    .catch(err => {
                        if (err.response?.status === 400) {
                            showToasts('Er bestaat al een speler met deze naam!', 'danger')
                        }
                    })
            })
    }

    const addExistingPlayerToLobby = (player: User) => {
        axios.patch(`/lobbies/${lobbyId}/join/${player.id}`)
            .then(() => showToasts('Speler toegevoegd!', 'success'));
    }

    const updateOwnerOfLobby = (userId: number) => {
        axios.patch(`/lobbies/${lobbyId}?userId=${userId}`)
            .then(() => showToasts('Streper succesvol aangepast!', 'success'))
    }

    function checkIfPlayDirectionHasChanged(players: any[]) {
        let gulpsDivided = Math.floor(players[0]?.gulps / 200);
        setClockWise((gulpsDivided % 2) === 0);
    }

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 992px)');
        setIsDesktop(mediaQuery.matches);

        const handleScreenSizeChange = (event: MediaQueryListEvent) => {
            setIsDesktop(event.matches);
        }

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', handleScreenSizeChange);
        } else {
            mediaQuery.addListener(handleScreenSizeChange as any);
        }

        const fetchCurrentLobby = () => {
            axios.get(`/lobbies/${lobbyId}/state`).then(res => handleLobbyStateUpdate(res.data));
        }
        const fetchPreviousPlayedPlayers = () => {
            axios.get(`/user/guest-players/new`).then(res => setPreviousPlayers(res.data));
        }
        const fetchPersonalData = () => {
            axios.get('/user/personal-data/header').then(res => setUser(res.data)).catch(console.error);
        }

        fetchCurrentLobby();
        fetchPersonalData();
        fetchPreviousPlayedPlayers();

        return () => {
            if (mediaQuery.removeEventListener) {
                mediaQuery.removeEventListener('change', handleScreenSizeChange);
            } else {
                mediaQuery.removeListener(handleScreenSizeChange as any);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const unsubState = subscribe(
            `/topic/dertigen/lobby/${lobbyId}`,
            (raw: any) => {
                try {
                    handleLobbyStateUpdate(raw);
                } catch (err) {
                    console.error("WS parse error:", err);
                }
            }
        );
        return () => {
            unsubState();
        };
    }, [subscribe, sendMessage, lobbyId]);

    useEffect(() => {
        switch (status) {
            case 'connected':
                showToasts('✅ Websocket verbinding', 'success');
                break;
            case 'disconnected':
                showToasts('⚠️ Verbinding verbroken', 'warning');
                break;
            case 'error':
                showToasts('❌ Er is een verbindingsfout opgetreden', 'danger');
                break;
        }
    }, [status]);

    useEffect(() => {
        measurePing();

        const intervalId = window.setInterval(() => {
            if (document.visibilityState === 'visible') {
                measurePing();
            }
        }, 10_000);

        const handleOnline = () => {
            measurePing();
        };

        const handleOffline = () => {
            setPingMs(null);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleLobbyStateUpdate = (res: any) => {
        setLobby(res.lobby);
        const sortedPlayers = res.players.sort((a: DertigenPlayer, b: DertigenPlayer) => b.gulps - a.gulps);
        const shouldDefaultExpand = window.matchMedia('(min-width: 992px)').matches;
        setPlayers(sortedPlayers);
        console.log("Sorted players:", sortedPlayers);
        setExpandedByPlayerId(prev => {
            const next: Record<number, boolean> = {};
            sortedPlayers.forEach((player: DertigenPlayer) => {
                if (prev[player.id] !== undefined) {
                    next[player.id] = prev[player.id];
                } else {
                    next[player.id] = shouldDefaultExpand;
                }
            });
            return next;
        });
        setLastMove(res.mostRecentMove);
        checkIfPlayDirectionHasChanged(sortedPlayers);
        setCurrentPlayerOnTurn(res.currentTurn?.currentPlayer);
        setThrowForPlayerId(res.currentTurn?.playerIdToThrowFor);

        // Recente beurten (server of client-accu)
        if (Array.isArray(res.recentMoves)) {
            setRecentMoves(res.recentMoves);
        } else if (res.mostRecentMove) {
            setRecentMoves(prev => {
                const withoutDup = prev.filter(m => m.id !== res.mostRecentMove.id);
                return [res.mostRecentMove, ...withoutDup].slice(0, 20);
            });
        }
    };

    const buyBackIn = () => {
        axios.patch(`/lobbies/buy-back/${lobbyId}`)
            .catch(() => showToasts('Er is iets mis gegaan', 'danger'))
    }

    const openMasterPicker = () => {
        presentPicker({
            buttons: [{text: 'Bevestig', handler: (selected) => updateOwnerOfLobby(selected.spelers.value)}],
            columns: [{
                name: "spelers",
                options: getColumnOptions()
            }]
        });
    }

    function getColumnOptions() {
        return players
            .filter((val: DertigenPlayer) =>
                (val.roles.includes('user') || val.roles.includes('dertigen-user')) &&
                val.id !== user?.id
            )
            .map((value: any) => ({text: value.name, value: value.id}));
    }

    function addPlayer() {
        presentAlert({
            header: 'Geef de naam in',
            buttons: [{text: 'OK', handler: (givenPlayer) => addNewPlayerToLobby(givenPlayer.name)}],
            inputs: [{name: "name", type: "text", placeholder: "Naam van speler"}],
        })
    }

    function performDeleteOnLastMove() {
        if (!lastMove?.id) return;
        axios.delete(`/lobbies/move/${lobbyId}/${lastMove.id}`)
            .then(() => {
                setRecentMoves(prev => prev.filter(m => m.id !== lastMove.id));
                setLastMove(undefined);
                showToasts("Beurt succesvol verwijderd", 'success')
            });
    }

    function performDeleteOnMove(moveId: number | undefined) {
        axios.delete(`/lobbies/move/${lobbyId}/${moveId}`)
            .then(() => {
                setRecentMoves(prev => prev.filter(m => m.id !== moveId));
                setLastMove(prev => (prev?.id === moveId ? undefined : prev));
                showToasts("Beurt succesvol verwijderd", 'success');
            })
            .catch(() => showToasts("Verwijderen mislukt", 'danger'));
    }

    const handleAddPlayer = (player: User) => {
        setShowAddPlayerModal(false);
        addExistingPlayerToLobby(player);
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };

    const filteredPlayers = previousPlayers?.filter(player =>
        player.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const navigateToStatutes = () => history.push(`/statutes`);

    const handleClick = (event: MouseEvent, playerId: DertigenPlayer) => {
        if (!isOwnerAndMachineControlled) {
            return;
        } else {
            openPopover(event, playerId);
        }
    };

    const togglePlayerExpansion = (playerId: number) => {
        setExpandedByPlayerId(prev => ({
            ...prev,
            [playerId]: !(prev[playerId] ?? isDesktop)
        }));
    }

    const handleScan = (codes: IDetectedBarcode[]) => {
        const value = codes?.[0]?.rawValue;
        if (value) {
            axios.get(`/dashboard-connect/connect?session=${value}&lobbyId=${lobbyId}`)
                .then(() => showToasts("Succesvol gescanned", 'success'))
            setShowQrReader(false)
        }
    }

    const visiblePlayers = showBuyedOutPlayers
        ? players
        : players.filter(p => p.stripes > 0);

    const renderLowerPart = () => {
        return (
            <>
                <IonFab vertical="bottom" horizontal="start" slot="fixed">
                    <IonFabButton onClick={() => navigateToStatutes()}>
                        <IonIcon icon={helpCircleSharp}/>
                    </IonFabButton>
                </IonFab>
                <IonFab color={"purple"} vertical="bottom" horizontal="end" slot="fixed">
                    <IonFabButton onClick={() => setShowQrReader(!showQrReader)}>
                        <IonIcon icon={scanCircleOutline}/>
                    </IonFabButton>
                </IonFab>

                {/* HERO: Laatste zet + Recent uitklappen */}
                {showLastMove && (
                    <>
                        <IonCard className="last-move-card">
                            <IonCardHeader className="ion-text-center">
                                <IonCardTitle class="last-move-card-title">Laatste zet</IonCardTitle>
                            </IonCardHeader>
                            <IonCardContent className="dertigen-label">
                                {lastMove?.drinkingMove && (
                                    <h2 className="last-move-card-title">
                                        {lastMove?.player} heeft {lastMove?.gulps} strepen gedronken
                                    </h2>
                                )}
                                {lastMove?.doubler && (
                                    <h2 className="last-move-card-title">
                                        {lastMove?.player} heeft iedereen verdubbeld!
                                    </h2>
                                )}
                                {!lastMove?.doubler && !lastMove?.drinkingMove && lastMove && (
                                    <h2 className="last-move-card-title">
                                        {lastMove?.player} heeft {lastMove?.stripes} strepen erbij gekregen
                                    </h2>
                                )}

                                <div style={{display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "center"}}>
                                    <IonButton color="medium" onClick={() => setShowRecentMoves(v => !v)}>
                                        {showRecentMoves ? "Verberg beurten" : `Recente beurten (${recentMoves.length})`}
                                    </IonButton>
                                    {showRemoveMovePanel && (
                                        <IonButton color="danger" onClick={() => performDeleteOnLastMove()}>
                                            Verwijder laatste
                                        </IonButton>
                                    )}
                                </div>
                            </IonCardContent>
                        </IonCard>

                        {showRecentMoves && (
                            <IonList>
                                {recentMoves.map((m, idx) => (
                                    <IonItem key={m.id ?? idx}>
                                        <IonLabel>
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                gap: 12
                                            }}>
                                                <div style={{display: "flex", flexDirection: "column"}}>
                                                    <strong>{m.player}</strong>
                                                    <small style={{opacity: 0.75}}>
                                                        {m.doubler
                                                            ? "Verdubbelaar"
                                                            : m.drinkingMove
                                                                ? `+${m.gulps} gedronken`
                                                                : `+${m.stripes} strepen`}
                                                    </small>
                                                </div>
                                                {showRemoveMovePanel && (
                                                    <IonButton size="small" color="danger"
                                                               onClick={() => performDeleteOnMove(m.id)}>
                                                        Verwijder
                                                    </IonButton>
                                                )}
                                            </div>
                                        </IonLabel>
                                    </IonItem>
                                ))}
                            </IonList>
                        )}
                    </>
                )}

                <IonList className="scoreboard-list">
                    {visiblePlayers.map((value: DertigenPlayer) => {
                        const isExpanded = expandedByPlayerId[value.id] ?? isDesktop;
                        return (
                        <IonCard
                            className={`player-score-card dertigen-card${value.stripes > 50 ? "-illegal" : value.stripes < 1 ? "-buyed-out" : ""} ${isExpanded ? 'expanded' : 'collapsed'}`}
                            key={value.id}
                            onClick={(e) => handleClick(e.nativeEvent as any, value)}
                        >
                            <div className="player-card-header">
                                <IonButton
                                    fill="clear"
                                    className="player-expand-toggle"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        togglePlayerExpansion(value.id)
                                    }}
                                    aria-label={isExpanded ? 'Klap speler dicht' : 'Klap speler open'}
                                >
                                    <IonIcon icon={isExpanded ? chevronUpOutline : chevronDownOutline}/>
                                </IonButton>

                                <IonLabel className="player-card-title">
                                    <div className='player-info-row'>
                                        {showProfilePictures && (
                                            <ProfilePicture
                                                profilePicUrl={value.profilePictureUrl !== undefined ? `${process.env.REACT_APP_STORAGE}${value.profilePictureUrl}` : `${process.env.REACT_APP_STORAGE}default-profile.jpg`}
                                                showEditable={false} width={30} height={30} fullName={value.name}
                                            />
                                        )}
                                        <h1 className='player-name'>
                                            {value.name}
                                            {value.id === currentPlayerOnTurn?.id && (
                                                <h4 className='turn-badge'>
                                                    <span className="full">🎲 Aan de beurt</span>
                                                    <span className="short" aria-label="Aan de beurt">🎲</span>
                                                </h4>
                                            )}
                                        </h1>
                                    </div>
                                </IonLabel>

                                <div className="player-header-metrics">
                                    <span className="metric-chip" aria-label={`Strepen ${value.stripes}`}>
                                        <IonIcon icon={ribbon}></IonIcon>
                                        {value.stripes}
                                    </span>
                                    <span className="metric-chip" aria-label={`Gedronken ${value.gulps}`}>
                                        <IonIcon icon={beer}></IonIcon>
                                            {value.gulps}
                                    </span>
                                </div>
                            </div>

                            {isExpanded && (
                                <IonCardContent className="player-card-body">
                                    <div className="player-badges-layout">
                                        <div className="player-side-badges" aria-label="Speler statistieken">
                                            <div className="side-badge" title="Verdubbelaars gegooid">
                                                <IonIcon icon={flashOutline}/>
                                                <span className="side-badge-label">Verdubbeld</span>
                                                <span className="side-badge-value">{value.doublersThrown ?? 0}</span>
                                            </div>
                                            <div className="side-badge" title="Straatjes uitgedeeld">
                                                <IonIcon icon={arrowUpCircleOutline}/>
                                                <span className="side-badge-label">Straat uit</span>
                                                <span className="side-badge-value">{value.streetThrowsGiven ?? 0}</span>
                                            </div>
                                            <div className="side-badge" title="Straatjes gekregen">
                                                <IonIcon icon={arrowDownCircleOutline}/>
                                                <span className="side-badge-label">Straat in</span>
                                                <span className="side-badge-value">{value.streetThrowsReceived ?? 0}</span>
                                            </div>
                                            <div className="side-badge" title="Eigen strepen gepakt">
                                                <IonIcon icon={addCircleOutline}/>
                                                <span className="side-badge-label">Zelf gepakt</span>
                                                <span className="side-badge-value">{value.ownStripesGained ?? 0}</span>
                                            </div>
                                        </div>

                                        <div className="badge-divider" aria-hidden="true"></div>

                                        <div className="player-main-badges" aria-label="Belangrijkste statistieken">
                                            <h3 className='badge-class badge-class-main'>
                                                <span className="badge-label-main">Strepen</span>
                                                <span>{value.stripes}</span>
                                            </h3>

                                            <h3 className='badge-class badge-class-main'>
                                                <span className="badge-label-main">Gedronken</span>
                                                <span>{value.gulps}</span>
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="player-status-row">
                                        <small>
                                            {value.stripes < 1 ? 'Status: Uitgekocht' : value.stripes > 50 ? 'Status: Mag niet gooien' : 'Status: Actief'}
                                        </small>
                                    </div>
                                </IonCardContent>
                            )}
                        </IonCard>
                        )
                    })}
                    {players
                        .filter((player: DertigenPlayer) => player.id === (user?.id) && player.stripes < 1)
                        .map((value: any, key: any) => (
                            <IonCard className='buy-in-card ion-text-center' key={key}>
                                <IonButton onClick={() => buyBackIn()}>Opnieuw inkopen</IonButton>
                            </IonCard>
                        ))}
                </IonList>

                {showPlayDirection && (
                    <IonLabel className={'play-direction-label'}>
                        <h1>{clockWise ? "Met de klok mee!" : "Tegen de klok in!"}</h1>
                    </IonLabel>
                )}
                {showDices && (
                    <IonCard className={'dice-container-div'}>
                        <DiceContainer/>
                    </IonCard>
                )}

                {showPlayDirection && (
                    <IonModal isOpen={showAddPlayerModal}>
                        <IonContent>
                            <IonInput
                                value={searchTerm}
                                placeholder="Zoek speler"
                                onIonInput={e => handleSearchChange(e as any)}
                            />
                            <IonList>
                                {filteredPlayers?.map((player, index) => (
                                    <IonItem key={index} button onClick={() => handleAddPlayer(player)}>
                                        {player.name}
                                    </IonItem>
                                ))}
                            </IonList>
                            <div className={'floating-button-container'}>
                                <IonButton onClick={addPlayer}>Nieuwe speler</IonButton>
                                <IonButton onClick={() => setShowAddPlayerModal(false)}>Sluit</IonButton>
                            </div>
                        </IonContent>
                    </IonModal>
                )}

                <DrinkStripesPopOver
                    isOpen={showPopover}
                    onClose={() => setShowPopover(false)}
                    selectedPlayer={playerToOpenPopoverFor}
                    lobbyId={Number(lobbyId)}
                    playersInLobby={players}
                />
            </>
        )
    }

    const switchCamera = () => {
        setScannerContraints(prevConstraints => ({
            ...prevConstraints,
            facingMode: prevConstraints.facingMode === 'user' ? 'environment' : 'user'
        }));
    };

    const openHeaderActionsMenu = (e: any) => {
        setHeaderActionsMenuEvent(e.nativeEvent);
        setShowHeaderActionsMenu(true);
    }

    const closeHeaderActionsMenu = () => {
        setShowHeaderActionsMenu(false);
        setHeaderActionsMenuEvent(undefined);
    }

    const isOwnerAndMachineControlled = user?.id === lobby?.ownerId && lobby?.isMachineControlledLobby;
    const pingClass = pingMs === null
        ? 'is-unknown'
        : pingMs <= 120
            ? 'is-good'
            : pingMs <= 250
                ? 'is-medium'
                : 'is-poor';
    const pingText = pingMs === null ? '-- ms' : `${pingMs} ms`;

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton/>
                    </IonButtons>
                    <IonTitle>Dertigen in {lobby?.name}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={openHeaderActionsMenu} aria-label="Open acties menu">
                            <IonIcon icon={settingsOutline} slot="icon-only"/>
                        </IonButton>
                    </IonButtons>

                    <IonPopover
                        isOpen={showHeaderActionsMenu}
                        event={headerActionsMenuEvent}
                        onDidDismiss={closeHeaderActionsMenu}
                    >
                        <IonList>
                            {lobby?.ownerId === user?.id && (
                                <>
                                    <IonItem button detail={false} onClick={() => {
                                        closeHeaderActionsMenu();
                                        openMasterPicker();
                                    }}>
                                        <IonLabel>Streper</IonLabel>
                                    </IonItem>
                                    <IonItem button detail={false} onClick={() => {
                                        closeHeaderActionsMenu();
                                        setShowAddPlayerModal(true);
                                    }}>
                                        <IonLabel>Toevoegen</IonLabel>
                                    </IonItem>
                                </>
                            )}
                            <IonItem button detail={false} onClick={() => {
                                closeHeaderActionsMenu();
                                setShowDialog(true);
                            }}>
                                <IonLabel>Instellingen</IonLabel>
                            </IonItem>
                        </IonList>
                    </IonPopover>

                    <IonModal isOpen={showDialog}>
                        <IonContent>
                            <IonList>
                                <IonItem>
                                    <IonLabel>Toon laatste zet</IonLabel>
                                    <IonToggle checked={showLastMove} onIonChange={showLastMoveToggle}/>
                                </IonItem>
                                <IonItem>
                                    <IonLabel>Uitgekochte spelers zichtbaar</IonLabel>
                                    <IonToggle checked={showBuyedOutPlayers} onIonChange={showBuyedOutPlayersToggle}/>
                                </IonItem>
                                <IonItem>
                                    <IonLabel>Speel richting zichtbaar</IonLabel>
                                    <IonToggle checked={showPlayDirection}
                                               onIonChange={() => setShowPlayDirection(!showPlayDirection)}/>
                                </IonItem>
                                <IonItem>
                                    <IonLabel>Virtuele dobbelstenen</IonLabel>
                                    <IonToggle checked={showDices} onIonChange={() => setShowDices(!showDices)}/>
                                </IonItem>
                                <IonItem>
                                    <IonLabel>Profiel foto's in beeld</IonLabel>
                                    <IonToggle checked={showProfilePictures} onIonChange={showProfilePicturesToggle}/>
                                </IonItem>
                                <IonItem>
                                    <IonLabel>Toon verwijderpaneel</IonLabel>
                                    <IonToggle checked={showRemoveMovePanel}
                                               onIonChange={() => setShowRemoveMovePanel(!showRemoveMovePanel)}/>
                                </IonItem>
                            </IonList>
                            <IonButton onClick={() => setShowDialog(false)}>Sluit</IonButton>
                        </IonContent>
                    </IonModal>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen>
                <div className={`connection-ping-pill ${pingClass}`} aria-live="polite">
                    <span className="connection-dot" aria-hidden="true"></span>
                    <span className="ping-value">{pingText}</span>
                </div>
                <div>
                    {isOwnerAndMachineControlled && (
                        <>
                            <div className={"move-input-container"}>
                                <DertigenMoveInput
                                    currentPlayer={currentPlayerOnTurn}
                                    lobbyId={Number(lobbyId)}
                                    throwForPlayerId={throwForPlayerId}
                                />
                                {isReorderVisible && <ReorderPlayers lobbyId={lobbyId}/>}
                                <div className={'reorder-button-container'}>
                                    <IonButton onClick={toggleReorderVisibility} className="toggle-reorder-btn">
                                        {isReorderVisible ? '↑' : '↓'}
                                    </IonButton>
                                </div>
                            </div>
                            <hr className={'seperator'}/>
                        </>
                    )}
                </div>

                {renderLowerPart()}

                <IonPopover isOpen={showQrReader}>
                    <div className="popover-content">
                        <h3 className="popover-title">Scan de dashboard QR</h3>
                        <Scanner
                            onScan={handleScan}
                            onError={(err) => console.error(err)}
                            constraints={scannerContraints}
                        />
                        <IonButton onClick={switchCamera}>Draai Camera</IonButton>
                        <p className="popover-hint">
                            Scan de QR code op het dashboard om deze lobby in de grafiek te krijgen.
                        </p>
                    </div>
                </IonPopover>
            </IonContent>
        </IonPage>
    )
}

export default DertigenList;
